/**
 * Different MediaDeviceKind types
 */
export enum MediaTypes {
    AUDIO_INPUT = 'audioinput',
    AUDIO_OUTPUT = 'audiooutput',
    VIDEO_INPUT = 'videoinput',
}
